import * as actions from '../../actions/actionTypes';
//
const initialState = [];
//
export default function rulesStore(state = initialState, action) {
  switch (action.type) {
    case actions.SET_RULES_STORE:
      if (action.payload) {
        return action.payload;
      } else {
        return state;
      }
    default:
      return state;
  }
}
